// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__3iFB-"};